import React, { useContext, useState, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Button, Select } from 'antd'
import GeneralContext from '../../context/GeneralContext/GeneralContext';
import api from '../../services/api';
import SL_Date from '../../components/dates/Date';
import { DateTime } from 'luxon';
import { displayMessage } from '../../services/helper';

const { Option } = Select;

export default function StatusFilters(props) {

    const [monitors, setMonitors] = useState([])
    const [currentFilters, setCurrentFilters] = useState({})

    const {setShowLoading, mobile_mode} = useContext(GeneralContext)

    useEffect(() => loadMonitors(), [])

    const loadMonitors = () => {
        setShowLoading(true)

        api.monitor.list().then(
            rs => {
                setMonitors(rs.data)
                setShowLoading(false)
            }
        )
    }

    const handleOnFilterChange = (type, value, parameterName) => {
        let currentFiltersUpdated = currentFilters

        if (type == 'date') {
            currentFiltersUpdated[parameterName] = value ? value.format('DD/MM/YYYY') : null
        }

        if (type == 'option') {
            currentFiltersUpdated[parameterName] = value
        }

        if (type == 'autocomplete') {
            currentFiltersUpdated[parameterName] = value
        }

        setCurrentFilters({ ...currentFiltersUpdated })
    }

    return (
        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'column',
                    width: '100%',
                    padding: 0,
                    marginBottom: 15,
                    color: 'white',
                    overflow: 'hidden',
                    border: '1px solid lightgrey',
                }
            }
        >
            <div className='flex flex-1 justify-between p-2 bg-appian-blue gap-1'>
                <span className='self-center font-medium text-white flex-1 text-center'>{displayMessage('APPOINTMENT_FILTERS')}</span>
            </div>

            <div style={{ display: 'flex', flexDirection: 'column', flex: 1, background: '#efefef' }}>

                <div style={{ display: 'flex', flexDirection: mobile_mode ? `column` : `row`, flex: 1, flexWrap: 'wrap', padding: 5, alignItems: 'center' }}>

                    <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', flexWrap: mobile_mode ? 'center' : 'wrap', flex: 1, width: mobile_mode && '100%', alignItems: mobile_mode && 'center' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5, alignItems: mobile_mode && 'center', width: mobile_mode && '100%'}}>
                            <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('MONITOR')}</div>
                            <Select
                                style={{ width: mobile_mode? 200 : 150 }}
                                size="middle"
                                value={currentFilters?.monitor_id}
                                placeholder={displayMessage('MONITOR_LIST')}
                                onChange={value => handleOnFilterChange('option', value, 'monitor_id')}
                                allowClear={true}
                            >
                                {
                                    monitors.map(
                                        d => <Option key={d.id} value={d.id}>{d.first_name + " " + d.last_name}</Option>
                                    )
                                }
                            </Select>
                        </div>
                        <div style={{ display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', flexWrap: mobile_mode ? 'center' : 'wrap', flex: 1, width: mobile_mode && '100%' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5, alignItems: mobile_mode && 'center', width: mobile_mode && '100%' }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('START_DATE')}:</div>
                                <SL_Date
                                    placeholder={displayMessage('SELECT_DATE')}
                                    style={{ width: 200, }}
                                    format={'DD/MM/YYYY'}
                                    onChange={start_date => setCurrentFilters({ ...currentFilters, start_date: start_date?.format('YYYY-MM-DD') })}
                                    disabledDate={
                                        (current) => {
                                            return currentFilters.end_date ? current && current > DateTime.fromISO(currentFilters.end_date) : false

                                        }
                                    }
                                />
                            </div>

                            <div style={{ display: 'flex', flexDirection: 'column', marginRight: 5, alignItems: mobile_mode && 'center', width: mobile_mode && '100%' }}>
                                <div style={{ fontWeight: 'bold', color: '#1b3663' }}> {displayMessage('END_DATE')}:</div>
                                <SL_Date
                                    placeholder={displayMessage('SELECT_DATE')}
                                    style={{ width: 200, }}
                                    format={'DD/MM/YYYY'}
                                    onChange={end_date => setCurrentFilters({ ...currentFilters, end_date: end_date?.format('YYYY-MM-DD') })}
                                    disabledDate={
                                        (current) => {
                                            return currentFilters.start_date ? current && current < DateTime.fromISO(currentFilters.start_date) : false
                                        }
                                    }
                                />
                            </div>

                        </div>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginLeft: 5, alignItems: 'flex-end', marginTop: 10, padding: 5 }}>
                        <Button
                            onClick={() => props.handleOnSearchSatusHistory(currentFilters)}
                            type="primary"
                            style={{ marginRight: 5, width: 200, height: 40, fontWeight: 'bold', borderRadius: 7 }}
                        >
                            {displayMessage('SEARCH')}
                        </Button>
                    </div>
                </div>
            </div>
        </div >


    )
}


